import { SET_ALERT_NOTIFICATION } from "constants/ActionTypes";

const initialState = {
  alertNotification: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT_NOTIFICATION:
      return {
        ...state,
        alertNotification: action.payload,
      };
    default:
      return state;
  }
};
